<template>
<div id="passenger-information-editor">

    <div class="fieldsets-flex">
     <fieldset id="info-targets">
        <legend>1. Julkaisu</legend>
        <div class='label-item priority'>
            <label>Tyyppi</label>
            <div>
                <div class='normal' v-if="priority == 'normal'" href="#" @click="priority = 'high'">Tiedote</div>
                <div class='high' v-if="priority == 'high'" href="#" @click="priority = 'normal'">Kriisi</div>
                <!--b-badge href="#"><b-icon icon="arrow-left-right"></b-icon></b-badge-->
                <t-button small type="icon" icon="arrow-left-right" title="Vaihda" @click="togglePriority()"></t-button>  
            </div>
         </div>
        <div id='publish' class="label-item"> 
            <label>Julkaisukanavat</label>
            <div>
            <p-checkbox :checked="true" :disabled="disabled" v-model="publishOnDisplays">Laiturinäytöt</p-checkbox>
            <p-checkbox :checked="true" :disabled="disabled">OMM</p-checkbox>
            </div>
        </div>
        
        <StationSelection :stations="stations"></StationSelection>
       
     </fieldset>

    <fieldset>
        <legend>2. Tekstit</legend>
        <div class='text-selection label-item'>
            <label>Tiedotepohja</label>
            <div>
                <SelectList id="template-selection" :options="templateOptions" @select="selectTemplate" :searchable="false" :clearable="false" :value="templateValue" :disabled="disabled" :selectable="option => !option.heading" />
            </div>
        </div>


        <div ref='fi' class="textarea fi" :class="{ disabled: disabled }" :contenteditable="!disabled">{{ editItem.fi }}</div>
        <div ref='se' class="textarea se" :class="{ disabled: disabled  }" :contenteditable="!disabled">{{ editItem.se }}</div>
        <div ref='en' class="textarea en" :class="{ disabled: disabled  }" :contenteditable="!disabled" >{{ editItem.en }}</div>
    </fieldset>
 

    <fieldset>
        <legend>3. Voimassaolo / esitysajat</legend>

        <ScheduleForm></ScheduleForm>

     </fieldset>
     </div>
    
    <t-button type="back" @click="close"></t-button> 
    
    <div style="float:right;">
        <t-button v-if="type == 'update'" type="rm" @click="remove" :disabled="loading"></t-button> 
        <t-button type="save" @click="save" :disabled="disabled"></t-button> 
    </div>
    
    <RequestInfo type="save" :loader="loading" :ok="ok"/>

    <DeleteModal  @ok="onDeleteOK" />

</div>

</template>

<script>


import StationSelection from './StationSelection.vue';
import ScheduleForm from './ScheduleForm.vue';

export default ({
    props: ['item', 'stations', 'type'],
    components: { StationSelection, ScheduleForm },
    data: function() {
        return {
            publishOnDisplays: true,
            priority: "normal",
            editItem : {},
            disabled: false,
            loading: false,
            ok: false,
            defaultTemplate: "01",
            priorityOptions: [
                { id: "0", label: "Normaali", class: 'highlight-option normal' },
                { id: "1", label: "Korkea", class: 'highlight-option high' },
            ],
         
            templateOptions: [
                { id: "01", label: "Ensitieto", class: 'heading', group: "01" },
                { id: "02", label: "Vapaa teksti", class: 'heading', group: "02" },
                { id: "1", label: "1. Totaalikatko", class: 'heading', group: 1 },
                { id: "2", label: "2. Harvennettu liikenne", class: 'heading', group: 2 },

                { id: "3", label: "3. YRA-liikenne", heading: true, group: 3 },
                { id: "3.1", label: "YRA-alue välillä KIL-TAP", icon: "caret-right-square-fill", group: 3 },
                { id: "3.2", label: "YRA-alue välillä TAP-RL", icon: "caret-right-square-fill", group: 3 },
                { id: "3.3", label: "YRA-alue välillä RL-IK", icon: "caret-right-square-fill", group: 3 },
                { id: "3.4", label: "YRA-alue välillä IK-VS/MM", icon: "caret-right-square-fill", group: 3 },
                
                { id: "4", label: "4. Osittainen liikenne lännestä", heading: true, group: 4},
                { id: "4.1", label: "Ensitieto", icon: "caret-right-square-fill", group: 4 },
                { id: "4.2", label: "Tarkempi tieto", icon: "caret-right-square-fill", group: 4 },
                
                { id: "5",  label: "5. Osittainen liikenne idästä", heading: true, group: 5 },
                { id: "5.1", label: "Ensitieto", icon: "caret-right-square-fill", group: 5 },
                { id: "5.2", label:"Tarkempi tieto", icon: "caret-right-square-fill", group: 5 },
                
                { id: "6", label: "6. Muut häiriötapaukset",  heading: true, group: 6 },
                { id: "6.1", label: "KIL-kääntö pois käytöstä", icon: "caret-right-square-fill", group: 6 },
                { id: "6.2", label: "TAP-kääntö pois käytöstä", icon: "caret-right-square-fill", group: 6 },
                { id: "6.3", label: "MM-kääntö pois käytöstä", icon: "caret-right-square-fill", group: 6 },
                { id: "6.4", label: "VS-kääntö pois käytöstä", icon: "caret-right-square-fill", group: 6 }
                     

            ],
            templates: [
                {   id: "01",
                    group: "Ensitieto",
                    fi: "Metroliikenteessä on häiriöitä. Lisätietoa hetken kuluttua.",
                    se: "Det finns störningar i metrotrafiken. Mer information om en stund.",
                    en: "There are disruptions in the metro service. More information soon."
                },
                
                {   id: "02",
                    group: "Vapaa teksti",
                    fi: "",
                    se: "",
                    en: "" 
                },
                {   id: "1",
                    group: "Totaalikatko",
                    fi: "Metroliikenne on keskeytetty toistaiseksi kokonaan. Älkää nousko juniin. Katsokaa lisätietoa hsl.fi",
                    se: "Det är tillsvidare stopp i metrotrafiken. Stig inte på tåget. För tilläggsinformation se HSL.fi.",
                    en: "Metro services are suspended until further notice. Do not board the trains. For more information, see HSL.fi." 
                },
                {   id: "2",
                    group: "Harvennettu liikenne",
                    fi: "Metroa liikennöidään poikkeuksellisesti harvennetulla vuorovälillä. <span class='fill'>*SYY*</span>.",
                    se: "Metron kör undantagsvis med glesare tidtabell. <span class='fill'>*ORSAK*</span>.",
                    en: "The metro is operating a reduced service. <span class='fill'>*REASON*</span>." 
                },
                {   id: "3.1",
                    group: "YRA-liikenne", 
                    fi: "Välillä Kivenlahti - Tapiola metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                    se: "På sträckan Stenvik - Hagalund kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                    en: "The metro is using only one track between Kivenlahti - Tapiola. The headways are irregular. <REASON>."
                },
                {   id: "3.2",
                    group: "YRA-liikenne",  
                    fi: "Välillä Tapiola - Ruoholahti metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                    se: "På sträckan Hagalund - Gräsviken kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                    en: "The metro is using only one track between Tapiola - Ruoholahti. The headways are irregular. <REASON>."
                },
                {   id: "3.3",
                    group: "YRA-liikenne",  
                    fi: "Välillä Ruoholahti - Itäkeskus metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                    se: "På sträckan Gräsviken - Östra centrum kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                    en: "The metro is using only one track between Ruoholahti - Itäkeskus. The headways are irregular. <REASON>."
                }, 
                {   id: "3.4",
                    group: "YRA-liikenne",  
                    fi: "Välillä Itäkeskus - Vuosaari metroa voidaan liikennöidä vain toista raidetta pitkin. Vuorovälit ovat epätasaiset. <SYY>.",
                    se: "På sträckan Östra centrum - Nordsjö kan metron köra endast på ett spår. Oregelbundna turer. <ORSAK>.",
                    en: "The metro is using only one track between Itäkeskus - Vuosaari. The headways are irregular. <REASON>."
                },
                {   id: "4.1", 
                    group: "Osittainen liikenne lännestä", 
                    fi: "Metroliikenteessä on häiriöitä. Lisätietoa hetken kuluttua.",
                    se: "Det finns störningar i metrotrafiken. Mer information om en stund.",
                    en: "There are disruptions in the metro service. More information soon."
                },
                {   id: "4.2", 
                    group: "Osittainen liikenne lännestä", 
                    fi: "Metroliikenne on keskeytetty välillä <A> - <B>. Lisätietoa osoitteessa hsl.fi.",
                    se: "Metron körs ej mellan <A> - <B>. Mer information på hsl.fi.",
                    en: "The Metro does not operate between <A> - <B>. More information on hsl.fi."
                },
                {   id: "5.1", 
                    group: "Osittainen liikenne idästä", 
                    fi: "Metroliikenteessä on häiriöitä. Lisätietoa hetken kuluttua.",
                    se: "Det finns störningar i metrotrafiken. Mer information om en stund.",
                    en: "There are disruptions in the metro service. More information soon."
                },
                {   id: "5.2", 
                    group: "Osittainen liikenne idästä", 
                    fi: "Metroliikenne on keskeytetty välillä <A> - <B>. Lisätietoa osoitteessa hsl.fi.",
                    se: "Metron körs ej mellan <A> - <B>. Mer information på hsl.fi.",
                    en: "The Metro does not operate between <A> - <B>. More information on hsl.fi."
                },
                {   id: "6.1", 
                    group: "Muut häiriötapaukset", 
                    fi: "Seuraava juna Vuosaareen lähtee laiturilta <X>.",
                    se: "Nästa tåg till Nordsjö avgår från spår <X>.",
                    en: "Next train to Vuosaari departs from track <X>."
                },
                {   id: "6.2",
                    group: "Muut häiriötapaukset",  
                    fi: "Linja M2 ei poikkeuksellisesti liikennöi välillä Tapiola Ruoholahti. Vuorovälit välillä Tapiola Ruoholahti ovat normaalia pidemmät. Lisätietoja hsl.fi.",
                    se: "Linje M2 trafikerar undantagsvis inte mellan Hagalund och Gräsviken. Metrotrafiken är glesare än normalt mellan Hagalund och Gräsviken. Mer information på hrt.fi.",
                    en: "NMetro line M2 does not exceptionally operate between Tapiola and Ruoholahti. Service is reduced between Tapiola and Ruoholahti. More info on hsl.fi."
                },
                {   id: "6.3",
                    group: "Muut häiriötapaukset",  
                    fi: "Seuraava juna Tapiolaan lähtee laiturilta <X>.",
                    se: "Nästa tåg till Hagalund avgår från spår <X>.",
                    en: "Next train to Tapiola/Kivenlahti departs from track <X>."
                },
                {   id: "6.4",
                    group: "Muut häiriötapaukset",  
                    fi: "Seuraava juna Kivenlahteen lähtee laiturilta <X>.",
                    se: "Nästa tåg till Stensvik avgår från spår <X>.",
                    en: "Next train to Kivenlahti departs from track <X>."
                }
            ],
            selectedTemplate: null,
             
        }
    },
    created(){
        if(this.item){
            this.editItem = {...this.item} 
        }
      

    },
    mounted(){
        if(!this.item) 
            this.selectTemplate(this.defaultTemplate);
    },
    computed: {
        templateValue(){
            return this.item ? this.item.template + "" : this.defaultTemplate;
        }
    },
    methods: {
      
        selectTemplate(id){
             let template = this.templates.find(t => t.id == id);
             if(template){
  
                this.selectedTemplate = template;
                this.$refs.fi.innerHTML = template.fi;
                this.$refs.se.innerHTML = template.se;
                this.$refs.en.innerHTML = template.en;
             }
             else {
                this.$refs.fi.innerHTML = "";
                this.$refs.se.innerHTML = "";
                this.$refs.en.innerHTML = "";
             }

        },
       
       
        save(){
            this.disabled = this.loading = true;
          
            let newItem = {};
            newItem.id = this.editItem.id;
            newItem.fi = this.removeHTML(this.$refs.fi.innerHTML);
            newItem.se = this.removeHTML(this.$refs.se.innerHTML);
            newItem.en = this.removeHTML(this.$refs.en.innerHTML);

            if(this.selectedTemplate){
                newItem.template = this.selectedTemplate.id.charAt(0);
                newItem.templateName = this.selectedTemplate.group;
            }
            newItem.state = 1;
           
            setTimeout(() => { 
                this.loading = false; 
                this.ok = true; 
                this.$emit('save', newItem);

            }, 1000);
           
        },
        removeHTML(input){
            return input.replace(/<[^>]*>/g, '');
        },
        remove(){
            //this.$emit('remove', this.item);
            this.$bvModal.show('delete-modal')
        },
        onDeleteOK(){
              this.$emit('remove', this.item);
        },
        close(){
            this.$emit('close');
        },
    
        togglePriority(){
            this.priority = this.priority == "normal" ? "high" : "normal";
        }

    
    }
    
})
</script>
